import { StudentSectionSettingTypeCodes } from 'const';
import { studyWidgetVisibilityHooks } from 'hooks';
import { IDataRequest } from 'hooks/dataLoad/useDataLoad';
import { performanceModel } from 'portfolio3/features/performance';
import { performanceOldModel } from 'portfolio3/features/performanceOld';
import {
  studyDocumentsSelector,
  studyGiaSelector,
  studyOlympiadsSelector,
  studySpoPracticeSelector,
  studySpoTrainingSelector,
  studyTrialExamSelector,
} from 'selectors';
import { getDataLoadRequests } from 'utils';

import { LoadingSelector, SectionLoaderConfig } from './types';

export const getStudyLoaderConfig = (isOldPerformanceWidget: boolean): SectionLoaderConfig => {
  const performanceLoadingSelector: LoadingSelector[] = [
    (state) => state.studentFinalGrades,
    (state) => state.studentAverageGrades,
  ];

  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyPerformance,
      requests: getDataLoadRequests().performanceOldEntryMethods,
      loadingSelector: (state) => state.studentPerformanceOld,
      dataSelector: performanceOldModel.selectors.isPerformanceWidgetHasDataSelector,
      useWidgetVisibility: studyWidgetVisibilityHooks.usePerformance,
      isDisabled: !isOldPerformanceWidget,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyPerformance,
      requests: getDataLoadRequests().performanceEntryMethods,
      loadingSelector: performanceLoadingSelector,
      dataSelector: performanceModel.selectors.isPerformanceWidgetHasDataSelector,
      useWidgetVisibility: studyWidgetVisibilityHooks.usePerformance,
      isDisabled: isOldPerformanceWidget,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyTraining,
      requests: getDataLoadRequests().studySpoEducation,
      loadingSelector: studySpoTrainingSelector,
      dataSelector: (state) => studySpoTrainingSelector(state).content.length > 0,
      useWidgetVisibility: studyWidgetVisibilityHooks.useSpoTraining,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyPractice,
      requests: getDataLoadRequests().studySpoEducation,
      loadingSelector: studySpoPracticeSelector,
      dataSelector: (state) => studySpoPracticeSelector(state).content.length > 0,
      useWidgetVisibility: studyWidgetVisibilityHooks.useSpoPractice,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyDocuments,
      requests: getDataLoadRequests().studySpoDocuments,
      loadingSelector: studyDocumentsSelector,
      dataSelector: (state) => studyDocumentsSelector(state).content.length > 0,
      useWidgetVisibility: studyWidgetVisibilityHooks.useSpoDocuments,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyGia,
      requests: getDataLoadRequests().studyGia,
      loadingSelector: studyGiaSelector,
      dataSelector: (state) => {
        const data = studyGiaSelector(state).content;
        const hasData = Object.values(data).some((examGroup) => examGroup.length > 0);
        return hasData;
      },
      useWidgetVisibility: studyWidgetVisibilityHooks.useGia,
    },
    // Заглушка для диагностик
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyDiagnostic,
      requests: [] as IDataRequest[],
      loadingSelector: () => ({ loading: false, requestCache: 'cached' }),
      dataSelector: () => false,
      useWidgetVisibility: () => ({ isSettingsMode: false, isWidgetVisible: true }),
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyOlympiad,
      requests: getDataLoadRequests().studyOlympiads,
      loadingSelector: studyOlympiadsSelector,
      dataSelector: (state) => studyOlympiadsSelector(state).content.length > 0,
      useWidgetVisibility: studyWidgetVisibilityHooks.useOlympiad,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.studyTrialExam,
      requests: getDataLoadRequests().studyGia,
      loadingSelector: studyTrialExamSelector,
      dataSelector: (state) => studyTrialExamSelector(state).content.length > 0,
      useWidgetVisibility: studyWidgetVisibilityHooks.useTrialExam,
    },
  ] as const;
};
